import { c as _c } from "react/compiler-runtime";
import { Icon } from "@/components/icons/interface";
export function ProjectGraph(t0) {
  const $ = _c(14);
  const {
    openCore
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <header><span>Functions <span aria-hidden="true">/</span> Double</span><span>Type</span></header>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="home-graph-terminal home-graph-node"><Icon name="arrow" /><h3>x</h3><span>Number</span><i className="home-graph-port home-graph-port-out" aria-hidden="true" /></div>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <svg className="home-graph-wire" viewBox="0 0 80 40" preserveAspectRatio="none" aria-hidden="true"><path className="home-graph-wire-horizontal" d="M0 20H80" /><path className="home-graph-wire-vertical" d="M40 0V40" /></svg>;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <header><Icon name="close" /><h3>Multiply</h3><span>Core</span></header>;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="home-graph-operation home-graph-node">{t4}<div className="home-graph-inputs"><div><i className="home-graph-port home-graph-port-in" aria-hidden="true" /><span>a</span><span className="home-graph-output">value</span><i className="home-graph-port home-graph-port-out" aria-hidden="true" /></div><div><i className="home-graph-port home-graph-port-in" aria-hidden="true" /><span>b</span><code>2</code></div></div></div>;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <svg className="home-graph-wire" viewBox="0 0 80 40" preserveAspectRatio="none" aria-hidden="true"><path className="home-graph-wire-horizontal" d="M0 20H80" /><path className="home-graph-wire-vertical" d="M40 0V40" /></svg>;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="home-graph-canvas" role="img" aria-label="Double function: the Number input x connects to Multiply. Its second input is the inline constant 2. The result connects to the Number output."><div className="home-graph-flow">{t2}{t3}{t5}{t6}<div className="home-graph-terminal home-graph-node"><i className="home-graph-port home-graph-port-in" aria-hidden="true" /><Icon name="arrow" /><h3>Result</h3><span>Number</span></div></div></div>;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <Icon name="package" />;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  let t9;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <Icon name="arrow" />;
    $[8] = t9;
  } else {
    t9 = $[8];
  }
  let t10;
  if ($[9] !== openCore) {
    t10 = <button onClick={openCore} aria-label="Open Core package">{t8}Core{t9}</button>;
    $[9] = openCore;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  let t11;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <span>Read-only preview</span>;
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  let t12;
  if ($[12] !== t10) {
    t12 = <div className="home-graph">{t1}{t7}<footer>{t10}{t11}</footer></div>;
    $[12] = t10;
    $[13] = t12;
  } else {
    t12 = $[13];
  }
  return t12;
}